import * as React from 'react';
import { useSelector } from 'react-redux';

import { useAppRedirectBannerVisible } from './hooks';
import { trackBlackFridayAppRedirectBannerClick, trackBlackFridayAppRedirectBannerShow } from './tracking';
import { BlackFridayAppRedirectBanner } from '../../components/BlackFridayAppRedirectBanner';
import { selectBlackFriday } from '../../selectors/blackFriday';

export const BlackFridayAppRedirectBannerContainer: React.FC = () => {
  const isVisible = useAppRedirectBannerVisible();

  const { appUrl } = useSelector(selectBlackFriday);

  if (!isVisible) {
    return null;
  }

  return (
    <BlackFridayAppRedirectBanner
      onClick={trackBlackFridayAppRedirectBannerClick}
      onShow={trackBlackFridayAppRedirectBannerShow}
      url={appUrl}
    />
  );
};
